import React, { useState, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft,faImage } from '@fortawesome/free-solid-svg-icons';
import Snackbar from './components/Snackbar'; 
import { useNotification } from '../context/NotificationContext';
import goldmedalicon from './images/goldmedalicon.png';
import speeddeliveryicon from './images/speeddeliveryicon.png';
import ArrowLeft from './images/ArrowLeft.png';
import defaultimg from './images/defaultimg.png';


// Skeleton Loader Component
const OrdersSkeleton = () => (
  <div className="animate-pulse p-4">
    {/* Navigation Skeleton */}
    <div className="h-12 bg-gray-200 rounded mb-4"></div>

    {/* Tabs Skeleton */}
    <div className="flex justify-between mb-4">
      {[1, 2, 3].map((tab) => (
        <div key={tab} className="h-8 bg-gray-200 rounded w-1/4"></div>
      ))}
    </div>

    {/* Order Card Skeletons */}
    {[1, 2, 3].map((card) => (
      <div key={card} className="bg-white rounded-lg shadow-sm mb-4 p-4">
        <div className="flex justify-between mb-2">
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        </div>
        
        <div className="flex items-center space-x-4 mb-2">
          <div className="w-16 h-16 bg-gray-300 rounded-lg"></div>
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
        
        <div className="flex justify-between">
          <div className="h-4 bg-gray-200 rounded w-1/3"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4"></div>
        </div>
      </div>
    ))}
  </div>
);

// Create a separate component for the order card with countdown
const OrderCard = ({ order, navigate }) => {
  const [countdown, setCountdown] = useState('');
  const [isExpired, setIsExpired] = useState(false);

useEffect(() => {
  const calculateCountdown = () => {
    // CHECK 1 → expireTime is valid
    if (!order.expireTime || isNaN(new Date(order.expireTime).getTime())) {
      setIsExpired(true);
      setCountdown("");
      return;
    }

    const expireTime = new Date(order.expireTime).getTime();
    const currentTime = new Date().getTime();
    const remainingTime = expireTime - currentTime;

    // CHECK 2 → if expired
    if (remainingTime <= 0) {
      setIsExpired(true);
      setCountdown("");
      return;
    }

    // Calculate mins, secs
    const minutes = Math.floor(remainingTime / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    // CHECK 3 → if NaN (invalid date)
    if (isNaN(minutes) || isNaN(seconds)) {
      setIsExpired(true);
      setCountdown("");
      return;
    }

    setCountdown(`${minutes}m ${seconds}sec`);
  };

  calculateCountdown();
  const interval = setInterval(calculateCountdown, 1000);
  return () => clearInterval(interval);

}, [order.expireTime]);


  // Helper function to get display status
  const getDisplayStatus = (vendor_status, fulfillmentStatus) => {
    if (vendor_status.toLowerCase() === 'awarded') {
      switch (fulfillmentStatus) {
        case 'Items Ready':
          return 'Items Ready';
        case 'Order Items Picked Up':
          return 'Shipped';
          case 'Delivery Partner Assigned':
            return 'Delivery Partner Assigned';
        case 'Not Started':
        case 'In Progress':
          return 'Awarded';
        default:
          return 'Awarded';
      }
    }
    return vendor_status.charAt(0).toUpperCase() + vendor_status.slice(1);
  };

  // Helper function to get status color
  const getStatusColor = (vendor_status, fulfillmentStatus) => {
    if (vendor_status.toLowerCase() === 'awarded') {
      return 'bg-[#E7FAD5] text-[#524D4D]';
    }
    
    switch (vendor_status.toLowerCase()) {
      case 'respond now':
        return 'bg-[#FFECEA] text-[#524D4D]';
      case 'accepted':
        return 'bg-[#E7FAD5] text-[#524D4D]';
      case 'counter offer':
        return 'bg-[#FDE7FF] text-[#524D4D]';
      case 'skipped':
        return 'bg-[#E7FAD5] text-[#524D4D]';
      default:
        return 'bg-red-100 text-red-800';
    }
  };

  return (
    <div key={order._id} className="border rounded-lg  hover:shadow-md transition-shadow">
      <div onClick={() => navigate(`/supplier/rfqdetails`, { 
            state: { quotationId: order._id , 
                     vendor_id : order.vendor_id,
                     from: 'orders' } 
          })} 
      className="p-4 flex flex-col justify-between">
        <div className='flex flex-row justify-between items-center'>
          <div className='flex flex-row justify-between items-center'>
            <p className="text-md font-semibold text-[#524D4D]">{order.orderNumber}</p>
           <span
  className={`ml-3 text-xs px-2 py-1 rounded-full flex items-center gap-1 font-semibold text-[#524D4D] ${
    getDisplayStatus(order.vendor_status, order.in_fulfillment_status) === 'Awarded'
      ? 'bg-[#FFF5C5]'
      : getDisplayStatus(order.vendor_status, order.in_fulfillment_status) === 'Shipped'
      ? 'bg-[#EFFAFF]'
      : getStatusColor(order.vendor_status, order.in_fulfillment_status)
  }`}
>
  {getDisplayStatus(order.vendor_status, order.in_fulfillment_status) === 'Awarded' && (
    <img src={goldmedalicon} alt="Awarded" className="w-4 h-4" />
  )}
  {getDisplayStatus(order.vendor_status, order.in_fulfillment_status) === 'Shipped' && (
    <img src={speeddeliveryicon} alt="Shipped" className="w-4 h-4" />
  )}
  {getDisplayStatus(order.vendor_status, order.in_fulfillment_status)}
</span>


            </div>
                     <p className="text-black text-md font-semibold">{order.total}</p>
          </div>

               <div className='flex flex-row justify-between items-center'>
          
        {(order.vendor_status.toLowerCase() === 'respond now') && !isExpired && countdown ? (
  <div className="mt-1 text-red-500 font-medium text-sm">
    <span className='text-[#524D4D]'>Closes in: </span>{countdown}
  </div>
) : (
  <div className="mt-1 text-gray-500 font-regular text-sm">
    {new Date(order.quotation_date).toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    })}
  </div>
)}

        </div>
      </div>

   <div className="flex items-center space-x-2 mb-2">
  {Array.isArray(order.items) &&
    order.items.slice(0, 4).map((item, index) => (
      <div
        key={item.item_id || index}
        className="ml-3 relative w-14 h-14 rounded-md overflow-hidden bg-gray-100"
      >
        <img
          src={
            item.item_image
              ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.item_image}`.trim()
              : defaultimg
          }
          alt={item.item_name || `Product ${index + 1}`}
          className="rounded-lg p-1 border border-gray-200 w-full h-full object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = defaultimg;
          }}
        />
      </div>
    ))}

  {Array.isArray(order.items) && order.items.length > 4 && (
    <div className="w-12 h-12 bg-gray-50  rounded-md flex items-center justify-center text-xs font-bold text-gray-600 border border-gray-200">
      +{order.items.length - 4}
    </div>
  )}
</div>

    </div>
  );
};

const RFQs = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('live'); // Changed default to 'live'
  const [orders , setOrders] = useState([]);
  const { notifications, setNotifications } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

   const [snackbarState, setSnackbarState] = useState({
      show: true,
      minimized: false
    });
     
    // Functions to control snackbar state
    const minimizeSnackbar = () => {
      setSnackbarState(prev => ({ ...prev, minimized: true }));
    };
    
    const expandSnackbar = () => {
      setSnackbarState(prev => ({ ...prev, minimized: false }));
    };
    
    const hideSnackbar = () => {
      setSnackbarState({ show: false, minimized: false });
    };

useEffect(() => {
    fetchQuotationsbyVendor();
  }, []);

 

  useEffect(() => {
  // Since all notifications are order-related, directly trigger refetch
  if (notifications && notifications.length > 0) {
    fetchQuotationsbyVendor();
  }
}, [notifications]);

  const fetchQuotationsbyVendor = async () => {
  try {
      setIsLoading(true);
      setError(null);
    // Parse vendorData from localStorage
    const vendorDataString = localStorage.getItem('vendorData');
    if (!vendorDataString) {
      console.error('No vendor data found in localStorage');
      return;
    }
    
    const vendorData = JSON.parse(vendorDataString);
    console.log('Vendor Data:', vendorData);
    
    if (!vendorData || !vendorData.id) {
      console.error('Invalid vendor data or missing vendor ID');
      return;
    }
    
    const token = sessionStorage.getItem('token') || vendorData.token;
    
    // Fetch quotations for this vendor
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-supplier-rfqs?supplier_id=${vendorData.id}&status=${activeTab}`, 
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    const data = await response.json();
    console.log('Quotations data:', data);
    
    if (data.success && Array.isArray(data.data)) {
      
      // Sort data by date (latest first) before processing
      const sortedData = data.data.sort((a, b) => {
        const dateA = new Date(a.rfq_date || a.created_at || new Date());
        const dateB = new Date(b.rfq_date || b.created_at || new Date());
        return dateB - dateA; // Latest first (descending order)
      });
      
      // Calculate the total number of quotations for ID assignment
      const totalQuotations = sortedData.length;
      
      // Transform quotations data to match the orders format
      const formattedOrders = sortedData.map((quotation, index) => {
        // Calculate time difference for "time" field
         const quotationDate = new Date(quotation.rfq_date || new Date());
        const now = new Date();
        const diffInDays = Math.floor((now - quotationDate) / (1000 * 60 * 60 * 24));
        const diffInMinutes = Math.floor((now - quotationDate) / (1000 * 60));
        
        let timeAgo;
        if (diffInDays > 0) {
          timeAgo = `${diffInDays}d ago`;
        } else if (diffInMinutes > 60) {
          timeAgo = `${Math.floor(diffInMinutes / 60)}h ago`;
        } else {
          timeAgo = `${diffInMinutes}min ago`;
        }
        
        // Get customer name from the quotation
        const customerName = quotation.customer_name || 'Customer';
        
        // Get address from project or use default
        const address = quotation.project_address || 'No address';
        
        // Format date
        const formattedDate = quotationDate.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
        
        // Since data is already sorted by latest first, index 0 is the newest
        const id = index + 1;
        
        return {
          id: id,
          _id: quotation._id,
          orderNumber: quotation.rfq_number,
          vendor_id: quotation.supplier_id,
          date: formattedDate,
          status: quotation?.status || '',
          vendor_status: quotation?.status ||'pending',
          items: quotation.items || [] ,
          total: `₹${Math.round(quotation.total).toLocaleString("en-US")}`,
          customer: customerName,
          time: timeAgo,
          address: address,
          createdAt: quotation.createdAt,
          quotation_date: quotation.rfq_date,
          in_fulfillment_status : quotation.in_fulfillment_status,
        expireTime: quotation?.waiting_time_expired_at 
             };
      });
      
      // Update the orders state with the formatted data (already sorted latest first)
      setOrders(formattedOrders);
    } else {
        throw new Error('Failed to fetch quotations or invalid data format');
      }
    } catch (error) {
      console.error('Error fetching quotations:', error);
      setError(error.message);
      setOrders([]);
    } finally {
      // Simulate loading for better UX
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  // Filter orders based on active tab
  const filteredOrders = orders.filter(order => {
    const vendor_status = order.vendor_status?.toLowerCase() || '';
    
    switch (activeTab) {
      case 'all':
        return true; // Show all orders
        
      case 'live':
        // Show only "Respond Now" status in Live tab
        return vendor_status === 'respond now';
        
      case 'responded':
        // Show "Counter Offer", "Accepted", "Not Awarded", "Awarded" in Responded tab
        return ['counter offer', 'accepted', 'not awarded', 'awarded'].includes(vendor_status);
        
      default:
        return true;
    }
  });

  // Sort responded orders to show "Awarded" first
  const sortedFilteredOrders = activeTab === 'responded' 
    ? [...filteredOrders].sort((a, b) => {
        // Put "Awarded" status first
        if (a.vendor_status?.toLowerCase() === 'awarded' && b.vendor_status?.toLowerCase() !== 'awarded') {
          return -1;
        }
        if (a.vendor_status?.toLowerCase() !== 'awarded' && b.vendor_status?.toLowerCase() === 'awarded') {
          return 1;
        }
        // For same status, maintain original order (latest first)
        return 0;
      })
    : filteredOrders;

  // Calculate counts for each tab
  const liveCount = orders.filter(order => order.vendor_status?.toLowerCase() === 'respond now').length;
  const respondedCount = orders.filter(order => 
    ['counter offer', 'accepted', 'not awarded', 'awarded'].includes(order.vendor_status?.toLowerCase())
  ).length;

  return (
    <div className="flex flex-col min-h-screen ">
     <div className="sticky top-0 z-50 bg-white h-14 shadow-md px-1 flex items-center">

  {/* Back Button */}
  <button 
    onClick={() => navigate('/supplier/home')} 
    className="active:scale-90 transition"
  >
    <img 
      src={ArrowLeft} 
      alt="Back"
      className="h-8 w-12"
    />
  </button>

  {/* Title */}
  <p className="text-lg font-semibold text-gray-800">
    RFQs
  </p>

</div>

        
      {/* Conditional Rendering */}
      {isLoading ? (
        <OrdersSkeleton />
      ) : error ? (
        <div className="flex items-center justify-center min-h-[calc(100vh-100px)] text-center p-4">
          <div>
            <p className="text-red-500 text-lg mb-4">
              {error || 'An error occurred while fetching orders'}
            </p>
            <button 
              onClick={fetchQuotationsbyVendor}
              className="bg-[#F43042] text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
            >
              Retry
            </button>
          </div>
        </div>
      ) : (
        <div className='mb-28 p-4'>
            <div className="text-xs flex flex-row justify-between  mb-6">
        <button
          className={`py-2 px-2 font-medium ${activeTab === 'live' ? ' border-b-2 border-[#D93025]' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setActiveTab('live')}
        >
          Live ({liveCount})
        </button>
        <button
          className={`py-2 px-2 font-medium ${activeTab === 'responded' ? ' border-b-2 border-[#D93025]' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setActiveTab('responded')}
        >
          Responded ({respondedCount})
        </button>
        <button
          className={`py-2 px-2 font-medium ${activeTab === 'all' ? ' border-b-2 border-[#D93025]' : 'text-gray-500 hover:text-gray-700'}`}
          onClick={() => setActiveTab('all')}
        >
          All  ({orders.length})
        </button>
      </div> 
      
        {/* Orders List */}
          <div className="space-y-4">
            {sortedFilteredOrders.length > 0 ? (
              sortedFilteredOrders.map(order => (
                <OrderCard 
                  key={order._id} 
                  order={order} 
                  navigate={navigate} 
                />
              ))
            ) : (
              <div className="flex flex-col items-center justify-center p-8 bg-white rounded-lg shadow-sm">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-20 w-20 text-gray-300 mb-4"
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M9 12l2 2 4-4M7 20l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" 
                  />
                </svg>
                <p className="text-gray-500 text-center">
                  {activeTab === 'live' 
                    ? 'No live RFQs found' 
                    : activeTab === 'responded'
                    ? 'No responded RFQs found'
                    : 'No RFQs found'
                  }
                </p>
                <button 
                  onClick={fetchQuotationsbyVendor}
                  className="mt-4 bg-[#F43042] text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
                >
                  Refresh
                </button>
              </div>
            )}
          </div>
        </div>
      )}

   <Snackbar 
                snackbarState={snackbarState}
                notifications={notifications}
                minimizeSnackbar={minimizeSnackbar}
                expandSnackbar={expandSnackbar}
                hideSnackbar={hideSnackbar}
            /> 
    </div>
  );
};

export default RFQs;